import Cloud from './Cloud'
import DataScience from './DataScience'
import DevOps from './DevOps'
import Python from './Python'
import Rpa from './Rpa'
import Sap from './Sap'

const TechPages = [Cloud, DevOps, DataScience, Rpa, Sap, Python]

export default TechPages